import React, { Suspense, lazy } from 'react';
import './App.css';
import 'leaflet/dist/leaflet.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, Routes } from "react-router-dom";
// IMPORTACION DE LAS PÁGINAS WEB DE MANERA INDIVIDUAL
import Home from './components/Home.js';
const Map = lazy(() => import('./components/Map.js'));
const Group = lazy(() => import('./components/Group.js'));
const Contact = lazy(() => import('./components/Contact.js'));
const Molnet = lazy(() => import('./components/Molnet.js'));
const Overview = lazy(() => import('./components/Overview.js'));
const TaxOverview = lazy(() => import('./components/TaxonomyData.js'));
const Explore = lazy(() => import('./components/Explore.js'));
const ExploreList = lazy(() => import('./components/ExploreList.js'));
const MoleculeDetails = lazy(() => import('./components/MolDet.js'));
const GenusDet = lazy(() => import('./components/GenusDetails.js'));

function App() {
  return (
    <div className="App">
      <Suspense fallback={<div>Loading...</div>}>
      <Routes>
      <Route path="/map" element={<Map />} />
      <Route exact path="/" element={<Home />} />
      <Route exact path="/group" element={<Group />} />
      <Route exact path="/overview" element={<Overview />} />
      <Route exact path="/contact" element={<Contact />} />
      <Route exact path="/molnet" element={<Molnet />} />
      <Route exact path="/taxoverview" element={<TaxOverview />} />
      <Route exact path="/explore" element={<Explore />} />
      <Route exact path="/explorelist" element={<ExploreList />} />
      <Route path="/explore/compound/:id" element={<MoleculeDetails />} />
      <Route path="/explore/genus/:id" element={<GenusDet />} />
      </Routes>
      </Suspense>
    </div>
  );
}

export default App;
